export function apiFactory(props) {
  const apiCommonMethods = props?.methods ?? [
    ['saveWorklog', '/trello/v2/saveWorklog', 'POST'],
    ['setTimerState', '/trello/setLiveWorklog', 'POST'],
    ['updateWorklog', '/trello/v2/updateWorklog', 'PUT'],
    ['deleteWorklog', '/trello/v2/deleteWorklog', 'DELETE'],
    ['getWorklogs', '/trello/getWorklogs', 'POST'],
    ['getWorklogsCached', '/trello/getWorklogs', 'GET'],
    ['getWorklogsMeta', '/trello/getWorklogsMeta', 'POST'],
    ['getWorklogsMetaCached', '/trello/getWorklogsMeta', 'GET'],
    ['getCardsStats', '/trello/v2/getCardsStats', 'POST'],
    ['getCardsArchive', '/trello/getCardsArchive', 'GET'],
    ['deleteScreenshot', '/trello/deleteScreenshot', 'POST'],
    ['getBoardAdminSettings', '/trello/settings/boardAdminSettings', 'GET'],
    [
      'getBoardMemberPermissions',
      '/trello/settings/boardMemberPermissions',
      'GET',
    ],
    ['setBoardUsersPermissions', '/trello/setBoardSettings', 'POST'],
    ['getBoardMemberSettings', '/trello/settings/boardMemberSettings', 'GET'],
    ['setBoardMemberSettings', '/trello/setBoardMemberSettings', 'POST'],
    ['setBoardAutoList', '/trello/setBoardAutoList', 'POST'],
    ['setInvoiceData', '/trello/setInvoiceData', 'POST'],
    ['subscription', '/trello/subscription', 'POST'],
    ['checkOrder', '/trello/checkStripeOrder', 'POST'],
    ['initialize', '/trello/initialize', 'POST'],
    ['decodeJWT', '/trello/decode-jwt', 'POST'],
    ['getBillingInfo', '/trello/getBillingInfo', 'GET'],
    ['getBillingHistory', '/trello/getBillingHistory', 'GET'],
    ['getFondyPayUrl', '/trello/getFondyPayUrl', 'POST'],
    ['getPayUrl', '/trello/getStripePayUrl', 'POST'],
    ['makeTestPayment', '/trello/makeTestPayment', 'POST'],
    ['saveTestWorkspaceBilling', '/trello/saveTestWorkspaceBilling', 'POST'],
    ['getPwaAuthKey', '/trello/getPwaAuthKey', 'GET'],
    ['getLastNews', '/trello/getLastNews', 'GET'],
    ['readLastNews', '/trello/readLastNews', 'POST'],
    ['getEstimates', '/trello/estimates', 'GET'],
    ['getBunchEstimates', '/trello/estimates/bunch', 'POST'],
    ['addEstimate', '/trello/estimates', 'POST'],
    ['updateEstimate', '/trello/estimates/{id}', 'PUT'],
    ['deleteEstimate', '/trello/estimates/{id}', 'DELETE'],
    ['migrateEstimates', '/trello/estimates/migrate', 'POST'],
    ['authPublicApi', '/trello/public/auth', 'POST'],
    ['exportCSV', '/trello/export/csv', 'POST'],
    ['getScheduleExport', '/trello/export/schedule', 'GET'],
    ['createScheduleExport', '/trello/export/schedule', 'POST'],
    ['sendVerificationCode', '/verify-email', 'POST'],
    ['checkVerificationCode', '/verify-email', 'GET'],
    ['getVerifiedEmail', '/verify-email/verifed-email', 'GET'],
  ];

  const baseHeaders = {
    Accept: 'application/json',
    Authorization: 'Bearer null',
    'Content-Type': 'application/json',
  };

  let makeRequest = props?.makeRequest ?? (() => {});
  let mockMethods = {};
  let token = null;
  let apiBaseUrl = null;

  function fillUrlTemplate(template, templateVars) {
    const re = new RegExp('{', 'g');
    return new Function(
      /* eslint-disable-line */ `return \`${template.replace(re, '${this.')}\`;`
    ).call(templateVars);
  }

  function buildQueryUrl(endpointUrl, params = {}) {
    const urlInstance = new URL(
      `${apiBaseUrl}${fillUrlTemplate(endpointUrl, params)}`
    );

    urlInstance.search = new URLSearchParams(params);
    return urlInstance.toString();
  }

  function performFetch({
    methodName,
    endpointUrl,
    method,
    params,
    body,
    headers,
  }) {
    const url = buildQueryUrl(endpointUrl, params);

    if (mockMethods[methodName]) {
      return mockMethods[methodName]({
        ...params,
        url,
        endpointUrl,
        headers: { ...baseHeaders, ...headers },
        ...(Object.keys(body).length
          ? {
              data: JSON.stringify(body),
            }
          : {}),
      });
    }

    const res = makeRequest({
      url,
      method,
      headers: { ...baseHeaders, ...headers },
      ...(Object.keys(body).length
        ? {
            data: JSON.stringify(body),
          }
        : {}),
    });
    return res;
  }

  function getEndpointUrl(methodName) {
    const methodInfo = apiCommonMethods.find(([name]) => name === methodName);
    if (!methodInfo) {
      throw new Error(`Method ${methodName} not found`);
    }
    const [_, endpointUrl] = methodInfo;
    return ['/api', endpointUrl].join('');
  }

  function getFullUrl(methodName, params = {}) {
    const methodInfo = apiCommonMethods.find(([name]) => name === methodName);
    if (!methodInfo) {
      throw new Error(`Method ${methodName} not found`);
    }
    const [_, endpointUrl] = methodInfo;
    return buildQueryUrl(endpointUrl, params);
  }

  return {
    init({ req, baseUrl }) {
      if (req) {
        makeRequest = req;
      }
      if (baseUrl) {
        apiBaseUrl = baseUrl;
      }
    },

    getEndpointUrl,
    getFullUrl,

    setMockMethods(mockObject, merge = true) {
      mockMethods = merge
        ? {
            ...mockMethods,
            ...mockObject,
          }
        : mockObject;

      return mockMethods;
    },

    clearMockMethods() {
      mockMethods = {};
      return mockMethods;
    },

    setJWT(jwt) {
      token = jwt;
      baseHeaders.Authorization = `Bearer ${jwt}`;
    },

    getJWT() {
      return token;
    },

    ...apiCommonMethods.reduce(
      (acc, [methodName, endpointUrl, method = 'GET']) => ({
        ...acc,
        [methodName](
          { params = {}, body = {}, headers = {} } = {
            params: {},
            body: {},
            headers: {},
          }
        ) {
          return performFetch({
            methodName,
            endpointUrl,
            method,
            params,
            body,
            headers,
          });
        },
      }),
      {}
    ),
  };
}

const api = apiFactory();

export default api;
